<div [class.modal-overlay]="!inline" [class.inline-wrapper]="inline" (click)="!inline && close.emit()">
  <div [class.modal]="!inline" [class.inline-content]="inline" (click)="$event.stopPropagation()">
    <div class="modal-header" *ngIf="!inline">
      <div class="header-content">
        <h3 class="modal-title">{{ 'componentsWizard.qrModal.header.title' | translate }}</h3>
        <p class="modal-subtitle">{{ 'componentsWizard.qrModal.header.subtitle' | translate }}</p>
      </div>
      <button class="btn-close" (click)="close.emit()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="qr-block">
        <div class="description-with-button">
          <p class="qr-description">{{ 'componentsWizard.qrModal.video.description' | translate }}</p>
          <div class="video-actions" [class.video-actions-inline]="inline">
            <button type="button" class="btn-chip-small" (click)="copyVideoUrl()">
              <img class="icon-16" src="/assets/copy.svg" alt="" />
              <span>{{ 'componentsWizard.qrModal.video.copyUrl' | translate }}</span>
            </button>
            <button type="button" class="btn-chip-small" (click)="downloadVideo()">
              <img class="icon-16" src="/assets/download.svg" alt="" />
              <span>{{ 'componentsWizard.qrModal.video.download' | translate }}</span>
            </button>
          </div>
        </div>
        <div class="video-container">
          <button type="button" class="fullscreen-btn" (click)="toggleFullscreen($event)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
            </svg>
          </button>
          <video controls width="100%">
            <source src="/assets/Waitora - Vidéo d'attente - VF.mp4" type="video/mp4">
            {{ 'componentsWizard.qrModal.video.unsupported' | translate }}
          </video>
        </div>
        <p class="qr-description">{{ 'componentsWizard.qrModal.printableIntro' | translate }}</p>

        <!-- Accordéon -->
        <div class="accordion">
          <!-- Section A4 -->
          <div class="accordion-item">
            <div class="accordion-header" (click)="toggleSection('a4')">
              <span class="accordion-title">{{ 'componentsWizard.qrModal.formats.a4.title' | translate }}</span>
              <div class="accordion-actions">
                <img [src]="qrUrl" alt="QR code" class="qr-mini" />
                <button type="button" class="btn-chip-small" (click)="downloadPoster('A4'); $event.stopPropagation()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.formats.downloadQr' | translate }}</span>
                </button>
                <button type="button" class="btn-chip-small" *ngFor="let lang of posterLanguages" (click)="downloadPoster('A4', lang.code); $event.stopPropagation()">
                  <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)" />
                  <span>{{ lang.label }}</span>
                </button>
                <button type="button" class="btn-chip-small" (click)="printGuide('A4'); $event.stopPropagation()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.formats.patientGuide' | translate }}</span>
                </button>
                <span class="accordion-icon">{{ expandedSection === 'a4' ? '▲' : '▼' }}</span>
              </div>
            </div>
            <div class="accordion-content expanded">
              <p class="accordion-description">{{ 'componentsWizard.qrModal.formats.a4.idealFor' | translate }}</p>
              <p class="accordion-description">{{ 'componentsWizard.qrModal.formats.a4.description' | translate }}</p>
            </div>
          </div>

          <!-- Section A5 -->
          <div class="accordion-item">
            <div class="accordion-header" (click)="toggleSection('a5')">
              <span class="accordion-title">{{ 'componentsWizard.qrModal.formats.a5.title' | translate }}</span>
              <div class="accordion-actions">
                <img [src]="qrUrl" alt="QR code" class="qr-mini" />
                <button type="button" class="btn-chip-small" (click)="downloadPoster('A5'); $event.stopPropagation()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.formats.downloadQr' | translate }}</span>
                </button>
                <button type="button" class="btn-chip-small" *ngFor="let lang of posterLanguages" (click)="downloadPoster('A5', lang.code); $event.stopPropagation()">
                  <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)" />
                  <span>{{ lang.label }}</span>
                </button>
                <button type="button" class="btn-chip-small" (click)="printGuide('A5'); $event.stopPropagation()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.formats.patientGuide' | translate }}</span>
                </button>
                <span class="accordion-icon">{{ expandedSection === 'a5' ? '▲' : '▼' }}</span>
              </div>
            </div>
            <div class="accordion-content expanded">
              <p class="accordion-description">{{ 'componentsWizard.qrModal.formats.a5.idealFor' | translate }}</p>
              <p class="accordion-description">{{ 'componentsWizard.qrModal.formats.a5.description' | translate }}</p>
            </div>
          </div>

          <!-- Section A6 -->
          <div class="accordion-item">
            <div class="accordion-header" (click)="toggleSection('a6')">
              <span class="accordion-title">{{ 'componentsWizard.qrModal.formats.a6.title' | translate }}</span>
              <div class="accordion-actions">
                <img [src]="qrUrl" alt="QR code" class="qr-mini" />
                <button type="button" class="btn-chip-small" (click)="downloadPoster('A6'); $event.stopPropagation()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.formats.downloadQr' | translate }}</span>
                </button>
                <button type="button" class="btn-chip-small" *ngFor="let lang of posterLanguages" (click)="downloadPoster('A6', lang.code); $event.stopPropagation()">
                  <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)" />
                  <span>{{ lang.label }}</span>
                </button>
                <button type="button" class="btn-chip-small" (click)="printGuide('A6'); $event.stopPropagation()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.formats.patientGuide' | translate }}</span>
                </button>
                <span class="accordion-icon">{{ expandedSection === 'a6' ? '▲' : '▼' }}</span>
              </div>
            </div>
            <div class="accordion-content expanded">
              <p class="accordion-description">{{ 'componentsWizard.qrModal.formats.a6.idealFor' | translate }}</p>
              <p class="accordion-description">{{ 'componentsWizard.qrModal.formats.a6.description' | translate }}</p>
            </div>
          </div>


        </div>
      </div>

      <div class="qr-block">
        <div class="accordion">
        <div class="accordion-item">
          <div class="accordion-header" (click)="toggleSection('etablissement')">
            <span class="accordion-title">{{ 'componentsWizard.qrModal.establishmentQr.title' | translate }}</span>
            <span class="accordion-icon">{{ expandedSection === 'etablissement' ? '▲' : '▼' }}</span>
          </div>
          <div class="accordion-content" [class.expanded]="expandedSection === 'etablissement'">
            <p class="accordion-description">{{ 'componentsWizard.qrModal.establishmentQr.description' | translate }}</p>
            <div class="qr-visual qr-visual-center">
              <img [src]="qrUrl" [attr.alt]="'componentsWizard.qrModal.establishmentQr.alt' | translate" />
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <div class="accordion-header" (click)="toggleSection('info-patient')">
            <span class="accordion-title">{{ 'componentsWizard.qrModal.patientInfoPreview.title' | translate }}</span>
            <span class="accordion-icon">{{ expandedSection === 'info-patient' ? '▲' : '▼' }}</span>
          </div>
          <div class="accordion-content" [class.expanded]="expandedSection === 'info-patient'">
            <div class="phone-mockup">
              <iframe [src]="getPatientPageUrl()" frameborder="0"></iframe>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <div class="accordion-header" (click)="toggleSection('tv-screen')">
            <span class="accordion-title">{{ 'componentsWizard.qrModal.tvScreen.title' | translate }}</span>
            <span class="accordion-icon">{{ expandedSection === 'tv-screen' ? '▲' : '▼' }}</span>
          </div>
          <div class="accordion-content" [class.expanded]="expandedSection === 'tv-screen'">
            <p class="accordion-description" style="margin: 0 0 10px;">{{ 'componentsWizard.qrModal.tvScreen.homeScreenLabel' | translate }}</p>
            <div style="display:flex;flex-direction:column;gap:6px">
              <div *ngFor="let lang of patientScreenLanguages" style="display:flex;align-items:center;justify-content:space-between;gap:8px">
                <span style="display:flex;align-items:center;gap:6px;font-size:12px;color:var(--mu, #6b6b78)">
                  <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)">
                  {{ lang.label }}
                </span>
                <button type="button" class="btn-chip-small" (click)="openTvScreenFor(lang.code)">
                  <img class="icon-16" src="/assets/preview.svg" alt="" />
                  <span>{{ 'componentsWizard.qrModal.tvScreen.openScreen' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <div class="accordion-header" (click)="toggleSection('widget-affluence')">
            <span class="accordion-title">{{ 'componentsWizard.qrModal.widget.title' | translate }}</span>
            <span class="accordion-icon">{{ expandedSection === 'widget-affluence' ? '▲' : '▼' }}</span>
          </div>
          <div class="accordion-content" [class.expanded]="expandedSection === 'widget-affluence'">
            <div class="kit-item" style="flex-direction:column;align-items:stretch">
              <div style="display:flex;align-items:center;justify-content:space-between">
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="kit-icon">🌐</div>
                  <div><div class="toggle-label">{{ 'componentsWizard.qrModal.widget.label' | translate }}</div><div class="toggle-sub">{{ 'componentsWizard.qrModal.widget.sub' | translate }}</div></div>
                </div>
                <div (click)="toggleWidget()" style="cursor:pointer" [class]="widgetEnabled ? 'toggle-on' : 'toggle-off'"></div>
              </div>
              <!-- Une ligne par langue active du site : widget.html est traduit et fixe sa langue via ?lang= -->
              <div *ngIf="widgetEnabled" style="display:flex;flex-direction:column;gap:6px;margin-top:10px;padding-left:46px">
                <div *ngFor="let lang of widgetLanguages" style="display:flex;align-items:center;justify-content:space-between;gap:8px">
                  <span style="display:flex;align-items:center;gap:6px;font-size:12px;color:#6b6b78">
                    <img [src]="flagIcon(lang.code)" [alt]="lang.label" style="width:18px;height:13px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08)">
                    {{ lang.label }}
                  </span>
                  <button type="button" class="btn-chip-small" (click)="copyWidgetUrlFor(lang.url)">
                    <img class="icon-16" src="/assets/copy.svg" alt="" />
                    <span>{{ 'componentsWizard.qrModal.widget.copyLink' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="nearby-config">
              <p class="accordion-description" style="margin-top:16px">{{ 'componentsWizard.qrModal.widget.nearbyIntro' | translate }}</p>

              <div class="queue-selector" style="display:flex;gap:8px;margin-bottom:12px" *ngIf="!nearbyLoading">
                <select [(ngModel)]="nearbyPickerId" style="flex:1">
                  <option value="" disabled selected>{{ 'componentsWizard.qrModal.widget.nearbyAddPlaceholder' | translate }}</option>
                  <option *ngFor="let c of nearbyCandidates" [value]="c.id">{{ c.name }}</option>
                </select>
                <button type="button" class="btn-chip-small" [disabled]="!nearbyPickerId || nearbyMutating" (click)="addNearby()">
                  <span>{{ 'componentsWizard.qrModal.widget.add' | translate }}</span>
                </button>
              </div>

              <div *ngIf="nearbyCandidates.length === 0 && !nearbyLoading && nearbySelected.length === 0" class="qr-explanation">
                <span>{{ 'componentsWizard.qrModal.widget.noOtherEstablishment' | translate }}</span>
              </div>

              <div style="display:flex;flex-direction:column;gap:8px" *ngIf="nearbySelected.length">
                <div class="kit-item" *ngFor="let n of nearbySelected">
                  <div style="display:flex;align-items:center;gap:10px">
                    <div class="kit-icon">📍</div>
                    <div><div class="toggle-label">{{ n.name }}</div><div class="toggle-sub" *ngIf="n.address">{{ n.address }}</div></div>
                  </div>
                  <button type="button" class="btn-chip-small" [disabled]="nearbyMutating" (click)="removeNearby(n.id)">
                    <span>{{ 'componentsWizard.qrModal.widget.remove' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <div class="accordion-header" (click)="toggleSection('prescripteur')">
            <span class="accordion-title">{{ 'componentsWizard.qrModal.forecastQr.title' | translate }}</span>
            <span class="accordion-icon">{{ expandedSection === 'prescripteur' ? '▲' : '▼' }}</span>
          </div>
          <div class="accordion-content" [class.expanded]="expandedSection === 'prescripteur'">
            <p class="accordion-description">{{ 'componentsWizard.qrModal.forecastQr.description' | translate }}</p>
            <ng-container *ngIf="prescripteurQrDataUrl; else prescripteurLoading">
              <div class="qr-visual qr-visual-center">
                <img [src]="prescripteurQrDataUrl" [attr.alt]="'componentsWizard.qrModal.forecastQr.alt' | translate" />
              </div>
              <div style="display:flex;align-items:center;gap:8px;margin-top:16px;flex-wrap:wrap">
                <button type="button" class="btn-chip-small" (click)="downloadPrescripteurPdf()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>PDF</span>
                </button>
                <button type="button" class="btn-chip-small" (click)="downloadPrescripteurSvg()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>SVG</span>
                </button>
                <button type="button" class="btn-chip-small" (click)="downloadPrescripteurPng()">
                  <img class="icon-16" src="/assets/download.svg" alt="" />
                  <span>PNG</span>
                </button>
              </div>

              <div class="kit-item" style="margin-top:16px">
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="kit-icon">🔍</div>
                  <div><div class="toggle-label">{{ 'componentsWizard.qrModal.forecastQr.searchToggleLabel' | translate }}</div><div class="toggle-sub">{{ 'componentsWizard.qrModal.forecastQr.searchToggleSub' | translate }}</div></div>
                </div>
                <div (click)="toggleSearchEnabled()" style="cursor:pointer" [class]="searchEnabled ? 'toggle-on' : 'toggle-off'"></div>
              </div>

              <div class="kit-item">
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="kit-icon">👁️</div>
                  <div><div class="toggle-label">{{ 'componentsWizard.qrModal.forecastQr.visibilityToggleLabel' | translate }}</div><div class="toggle-sub">{{ 'componentsWizard.qrModal.forecastQr.visibilityToggleSub' | translate }}</div></div>
                </div>
                <div (click)="togglePrescripteurVisible()" style="cursor:pointer" [class]="prescripteurVisible ? 'toggle-on' : 'toggle-off'"></div>
              </div>
            </ng-container>
            <ng-template #prescripteurLoading>
              <p class="accordion-description">{{ 'componentsWizard.qrModal.forecastQr.loading' | translate }}</p>
            </ng-template>
          </div>
        </div>

        <div class="accordion-item" *ngIf="false">
          <div class="accordion-header" (click)="toggleSection('files-attente')">
            <span class="accordion-title">{{ 'componentsWizard.qrModal.queueQr.title' | translate }}</span>
            <span class="accordion-icon">{{ expandedSection === 'files-attente' ? '▲' : '▼' }}</span>
          </div>
          <div class="accordion-content" [class.expanded]="expandedSection === 'files-attente'">
            <p class="qr-description">{{ 'componentsWizard.qrModal.queueQr.description' | translate }}</p>
            <div class="queue-selector">
              <select [(ngModel)]="selectedQueueId">
                <option *ngFor="let q of queues" [value]="q.id">{{ q.name }}</option>
              </select>
            </div>
            <div class="qr-visual qr-visual-center">
              <img [src]="queueQrUrl()" [attr.alt]="'componentsWizard.qrModal.queueQr.alt' | translate" />
            </div>
            <div class="qr-explanation">
              <svg class="info-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#6b7280" stroke-width="2"/>
                <path d="M12 16v-4M12 8h.01" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ 'componentsWizard.qrModal.queueQr.info' | translate }}</span>
            </div>

            <div class="accordion">
              <div class="accordion-item">
                <div class="accordion-header" (click)="toggleSection('queue-a5')">
                  <span class="accordion-title">{{ 'componentsWizard.qrModal.queueQr.a5Title' | translate }}</span>
                  <div class="accordion-actions">
                    <img [src]="queueQrUrl()" alt="QR code" class="qr-mini" />
                    <button type="button" class="btn-chip-small" (click)="onDownloadQueueQr(); $event.stopPropagation()">
                      <img class="icon-16" src="/assets/download.svg" alt="" />
                      <span>{{ 'componentsWizard.qrModal.formats.downloadQr' | translate }}</span>
                    </button>
                    <span class="accordion-icon">{{ expandedSection === 'queue-a5' ? '▲' : '▼' }}</span>
                  </div>
                </div>
                <div class="accordion-content" [class.expanded]="expandedSection === 'queue-a5'">
                  <p class="accordion-description">{{ 'componentsWizard.qrModal.queueQr.a5Description' | translate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="copy-toast" *ngIf="showCopyToast">
  <span class="ora-ico-badge">
    <img class="ora-ico" src="/assets/IconORA.svg" alt="">
  </span>
  <span class="ora-txt">
    <span class="ora-title">{{ 'componentsWizard.qrModal.copyToast.title' | translate }}</span>
    <span class="ora-sub">{{ 'componentsWizard.qrModal.copyToast.subtitle' | translate }}</span>
  </span>
</div>
